/* Signup popup behaviour:
   - opens via any [data-signup-open] (menu "Join the team", footer link) or
     automatically once after the configured delay (Odd Ritual's ~6s) —
     never again after being dismissed (localStorage), and never while the
     menu / cart drawer / another overlay is open
   - the form posts natively to Shopify (no AJAX endpoint exists for the
     customer form); after the redirect the section renders the success or
     error state and sets data-state, which re-opens the popup immediately
   - close: X, backdrop, Escape; scroll lock + focus handling like the menu */
(function () {
  var root = document.querySelector('[data-signup]');
  if (!root) return;

  var SEEN_KEY = 'onni-signup-dismissed';
  var lastFocused = null;

  function seen() {
    try {
      return window.localStorage.getItem(SEEN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSeen() {
    try {
      window.localStorage.setItem(SEEN_KEY, '1');
    } catch (e) {
      /* private mode — fine, it'll just auto-show again next visit */
    }
  }

  function otherOverlayOpen() {
    return !!document.querySelector('[data-menu].is-open, .onni-cart.is-open');
  }

  function isOpen() {
    return root.classList.contains('is-open');
  }

  function open() {
    if (isOpen()) return;

    // the popup sits above the fullscreen menu (z-index 1250 > 1000), so it can
    // open right on top of it — leave the menu open behind it

    lastFocused = document.activeElement;
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';

    var closeBtn = root.querySelector('[data-signup-close]:not(.onni-signup_backdrop)');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    // keep scroll locked if another overlay (menu / cart) is still open
    if (!document.querySelector('[data-menu].is-open, .onni-cart.is-open')) {
      document.documentElement.style.overflow = '';
    }
    markSeen();

    setTimeout(function () {
      if (!isOpen()) root.hidden = true;
    }, 550);

    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-signup-open]');
    if (opener) {
      e.preventDefault();
      open();
      return;
    }
    var closer = e.target.closest('[data-signup-close]');
    if (closer && root.contains(closer)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  /* the inline footer form uses the same Shopify customer form, so a footer
     submit also flips form.posted_successfully? here — flag its source so we
     don't pop the modal open on top of the footer's own confirmation.
     Delegated on document: the footer lives inside the Barba container and is
     replaced on every navigation, so an element-bound listener would die. */
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'onni-footer-signup') {
      try { window.sessionStorage.setItem('onni-signup-source', 'footer'); } catch (err) {}
    }
  });

  /* Barba navigation: snap shut instantly — and deliberately NO markSeen():
     navigating away is not a dismissal, the auto-open stays available */
  document.addEventListener('onni:page:out', function () {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.style.overflow = '';
  });

  /* came back from a form post: show the result right away */
  if (root.querySelector('[data-signup-state]')) {
    var source = null;
    try {
      source = window.sessionStorage.getItem('onni-signup-source');
      window.sessionStorage.removeItem('onni-signup-source');
    } catch (e) {}
    markSeen(); // don't also auto-nag afterwards
    if (source !== 'footer') open(); // footer submit → let its inline "Kiitos" show, no modal
    return;
  }

  /* auto-open, once ever */
  var delay = parseInt(root.dataset.delay, 10) || 0;
  if (delay > 0 && !seen()) {
    setTimeout(function () {
      if (!seen() && !isOpen() && !otherOverlayOpen()) open();
    }, delay * 1000);
  }
})();
